import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';

import {AccordionModule, BsDropdownModule, TabsModule} from 'ngx-bootstrap';

import {BasicLayoutComponent} from './basicLayout.component';
import {BlankLayoutComponent} from './blankLayout.component';
import {TopNavigationLayoutComponent} from './topNavigationLayout.component';

import {NavigationComponent} from './../navigation/navigation.component';
import {FooterComponent} from './../footer/footer.component';
import {TopNavbarComponent} from './../topnavbar/topnavbar.component';
import {TopNavigationNavbarComponent} from './../topnavbar/topnavigationnavbar.component';

// LoginSystem //Sidebar layouts
import {ClientLayoutComponent} from './clientLayout.component';
import {NavigationClientComponent} from './../navigation/navigationClient.component';
import {StaffLayoutComponent} from './staffLayout.component';
import {NavigationStaffComponent} from './../navigation/navigationStaff.component';
import {ManagerLayoutComponent} from './managerLayout.component';
import {NavigationManagerComponent} from './../navigation/navigationManager.component';
import {AdminLayoutComponent} from './adminLayout.component';
import {NavigationAdminComponent} from './../navigation/navigationAdmin.component';
import {AgentLayoutComponent} from './agentLayout.component';
import {NavigationAgentComponent} from './../navigation/navigationAgent.component';
// import { JobSubjectSearchWidgetComponent } from 'app/components/jobs/job-subject-search-widget/job-subject-search-widget.component';
// import { TodoComponent } from 'app/admin/todo/todo/todo.component';
// import { TodoItemComponent } from 'app/admin/todo/todo-item/todo-item.component';
// import { DateAgoPipe } from 'app/pipes/date-ago.pipe';
import {routes} from './../../../app-routing.module';
import { TodoComponent } from 'src/app/admin/todo/todo/todo.component';
import { TodoItemComponent } from 'src/app/admin/todo/todo-item/todo-item.component';

// import the DropDownListModule for the DropDownList component
import { AutoCompleteModule, ComboBoxModule, DropDownListModule, ListBoxModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { SystemForceLogoutWidgetComponent } from 'src/app/admin/system-force-logout-widget/system-force-logout-widget.component';
// import { AppRouteCreateWidgetComponent } from 'src/app/admin/system-routes/app-route-create-widget/app-route-create-widget.component';
// import { AppRouteHelperComponent } from 'src/app/admin/system-routes/app-route-helper/app-route-helper.component';
// import { AppRouteUpdateWidgetComponent } from 'src/app/admin/system-routes/app-route-update-widget/app-route-update-widget.component';
// import { AppRouteWidgetComponent } from 'src/app/admin/system-routes/app-route-widget/app-route-widget.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { DatePickerModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MenuModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { IboxtoolsModule } from '../iboxtools/iboxtools.module';
import { AppRouteUpdateWidgetComponent } from 'src/app/admin/system-routes/app-route-update-widget/app-route-update-widget.component';
import { AppRouteCreateWidgetComponent } from 'src/app/admin/system-routes/app-route-create-widget/app-route-create-widget.component';

import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { JobsFileGridComponent } from '../../grid/jobs-file-grid/jobs-file-grid.component';
import { AppRouteHelperComponent } from 'src/app/admin/system-routes/app-route-helper/app-route-helper.component';
import { AppRouteWidgetComponent } from 'src/app/admin/system-routes/app-route-widget/app-route-widget.component';
import { AppRouteBillingItemsGridComponent } from '../../grid/app-route-billing-items-grid/app-route-billing-items-grid.component';
import { AddSubjectBillingItemWidgetComponent } from 'src/app/admin/jobs/subjects/subject-billing/add-subject-billing-item-widget/add-subject-billing-item-widget.component';
import { AppRouteBillingItemUpdateComponent } from 'src/app/admin/system-routes/app-route-billing-item-update/app-route-billing-item-update.component';
import { AppRoutesDiagramKanPanDataComponentComponent } from 'src/app/admin/system-routes/app-routes-diagram-kan-pan-data-component/app-routes-diagram-kan-pan-data-component.component';
import { KanbanModule } from '@syncfusion/ej2-angular-kanban';
import { SystemHelpVarsComponent } from 'src/app/admin/system-help-vars/system-help-vars.component';
import { AppRouteHelperPlayerWidgetComponent } from 'src/app/admin/system-routes/app-route-helper-player-widget/app-route-helper-player-widget.component';
import { AppRoutesDiagramKanBanSearchComponent } from 'src/app/admin/system-routes/app-routes-diagram-kan-ban-search/app-routes-diagram-kan-ban-search.component';
import { AppRoutesDiagramKanBanComponent } from 'src/app/admin/system-routes/app-routes-diagram-kan-ban/app-routes-diagram-kan-ban.component';
import { AppRoutesDiagramHierarchialComponent } from 'src/app/admin/system-routes/app-routes-diagram-hierarchial/app-routes-diagram-hierarchial.component';
import { DiagramModule } from '@syncfusion/ej2-angular-diagrams';
import { UnderTheHoodWidgetComponent } from 'src/app/admin/system-routes/under-the-hood-widget/under-the-hood-widget.component';
import { DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { AppRoutesGridComponent } from 'src/app/admin/system-routes/app-routes-grid/app-routes-grid.component';
import { ScrollTopComponent } from '../scroll-top/scroll-top.component';
import { SystemNoticeBannerComponent } from 'src/app/admin/system-notices/system-notice-banner/system-notice-banner.component';


@NgModule({
  declarations: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    ClientLayoutComponent,
    NavigationComponent,
    NavigationClientComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    StaffLayoutComponent,
    NavigationStaffComponent,
    ManagerLayoutComponent,
    NavigationManagerComponent,
    AdminLayoutComponent,
    NavigationAdminComponent,
    AgentLayoutComponent,
    NavigationAgentComponent,
    TodoComponent,
    TodoItemComponent,
    SystemForceLogoutWidgetComponent,
    
    AppRouteWidgetComponent,
    AppRouteHelperComponent,
    AppRouteCreateWidgetComponent,
    AppRouteUpdateWidgetComponent,
    AppRouteBillingItemsGridComponent,
    // AssignSystemFileWidgetComponent,
    AddSubjectBillingItemWidgetComponent,
    AppRouteBillingItemUpdateComponent,
   SystemHelpVarsComponent,
   AppRouteHelperPlayerWidgetComponent,
   AppRoutesDiagramKanBanComponent,
   AppRoutesDiagramKanBanSearchComponent,
   AppRoutesDiagramKanPanDataComponentComponent,
   AppRoutesDiagramHierarchialComponent,
   UnderTheHoodWidgetComponent,
AppRoutesGridComponent,
ScrollTopComponent,
SystemNoticeBannerComponent

  ],
  imports: [
    BrowserModule,
    RouterModule,
    // BsDropdownModule.forRoot()
    DropDownListModule,
    DropDownButtonModule,
    [RouterModule.forRoot(routes, {useHash: true})],
    TabsModule.forRoot(),
    IboxtoolsModule,
    FormsModule,
    HttpClientModule,

    CodemirrorModule,


    ButtonModule,
    GridModule,
    MenuModule,
    BrowserModule,
      // Registering EJ2 filemanager Module
     //  RichTextEditorModule,
      RichTextEditorAllModule,
      MultiSelectModule,
      DatePickerModule,
      DateTimePickerAllModule,
      DialogModule,
      DropDownListModule,
      ComboBoxModule,
      AutoCompleteModule,
      // TreeViewModule,
      AccordionModule,
      ListBoxModule,
      KanbanModule,
DiagramModule,
DashboardLayoutModule,


  ],
  exports: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    ClientLayoutComponent,
    NavigationComponent,
    NavigationClientComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    StaffLayoutComponent,
    NavigationStaffComponent,
    ManagerLayoutComponent,
    NavigationManagerComponent,
    AdminLayoutComponent,
    NavigationAdminComponent,
    [RouterModule.forRoot(routes, {useHash: true})],
    AppRouteWidgetComponent,
    AppRouteHelperComponent,
    AppRouteCreateWidgetComponent,
    AppRouteUpdateWidgetComponent,
    AppRouteBillingItemsGridComponent,
    AddSubjectBillingItemWidgetComponent,
    AppRouteBillingItemUpdateComponent,
    SystemHelpVarsComponent,
   AppRouteHelperPlayerWidgetComponent,
   AppRoutesDiagramKanBanComponent,
   AppRoutesDiagramKanBanSearchComponent,
   AppRoutesDiagramKanPanDataComponentComponent,
   AppRoutesDiagramHierarchialComponent,
   UnderTheHoodWidgetComponent,
AppRoutesGridComponent,
SystemNoticeBannerComponent



  ],
})

export class LayoutsModule {}
